import { Spinner, View } from 'tamagui'

export default () => (
    <View
        position="fixed"
        top={0}
        left={0}
        width="100vw"
        height="100vh"
    >
        <View
            width={100}
            height={100}
            position="absolute"
            top="50%"
            left="50%"
            marginTop={-50}
            marginLeft={-50}
            alignItems="center"
            justifyContent="center"
        >
            <Spinner size="large" color="$primary" />
        </View>
    </View>
)
